<template>
  <div>
    <!-- CREATE MODAL -->
    <b-modal id="modal-extraunit" title="Qo'shimcha nom" hide-footer size="lg"
      @shown="Shovedform('modal-extraunitlist')" @hidden="Hidecreate()"
      modal-class="modern-modal">
      <div class="modal-form">
        <div class="form-unit">
          <label>{{ $t("Номи") }}</label>
          <input class="form-input" ref="inputText1" v-model="extraunitnew.name" type="text" :placeholder="$t('Kiriting...')" />
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-save" @click="Create()">
            <b-icon icon="check-all" class="mr-1"></b-icon> {{ $t("Сақлаш") }}
          </button>
        </div>
      </div>
    </b-modal>

    <!-- UPDATE MODAL -->
    <b-modal id="modal-extraunitset" title="Qo'shimcha nom" hide-footer size="lg"
      @shown="Shovedform('modal-extraunitlist')" @hidden="Hidecreate()"
      modal-class="modern-modal">
      <div class="modal-form">
        <div class="form-unit">
          <label>{{ $t("Номи") }}</label>
          <input class="form-input" ref="inputText1" v-model="extraunit.name" type="text" />
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-save" @click="Update()">
            <b-icon icon="check-all" class="mr-1"></b-icon> {{ $t("Сақлаш") }}
          </button>
        </div>
      </div>
    </b-modal>

    <!-- LIST MODAL -->
    <b-modal id="modal-extraunitlist" title="Qo'shimcha nomlar" hide-footer size="xl"
      @shown="Shoved" @hidden="Hide()"
      modal-class="modern-modal">
      <div class="modal-list">
        <div class="modal-list-header">
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input type="text" class="modern-search" :placeholder="$t('Qidiruv...')" v-model="filter" ref="inputText1" />
          </div>
          <button type="button" class="add-btn" v-b-modal.modal-extraunit>
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}
          </button>
        </div>

        <div class="modal-table-wrapper">
          <table class="modal-table">
            <thead>
              <tr>
                <th style="width:60px">#</th>
                <th>{{ $t("Номи") }}</th>
                <th style="width:120px;text-align:center">{{ $t("Amallar") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredRows" :key="index"
                @click="Selected(item.id); $bvModal.hide('modal-extraunitlist');" class="clickable-row">
                <td><span class="id-badge">{{ index + 1 }}</span></td>
                <td class="font-bold">{{ item.name }}</td>
                <td @click.stop>
                  <div class="actions">
                    <button type="button" class="icon-btn edit"
                      @click="extraunit = filteredRows[index]; sett = index;" v-b-modal.modal-extraunitset>
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button type="button" class="icon-btn del" @click="Extraunittrash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="filteredRows.length === 0">
                <td colspan="3" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import $ from "jquery";
import { toggle } from "../../components/mixins/mymixin.js";
export default {
  name: "extraunit",
  mixins: [toggle],
  data() {
    return {
      focusset: "",
      filter: "",
      sett: null,
      extraunit: { name: "" },
      extraunitnew: { name: "" },
      extraunitlist: [],
      select: 0
    };
  },
  methods: {
    Extraunittrash(id) {
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        let self = this;
        axios({
          method: "delete",
          url: "api/v1/extra-unit/id/" + id
        }).then(function(response) {
          self.Extraunitlist();
        });
      }
    },
    Extraunitlist() {
      let self = this;
      axios.get("api/v1/extra-unit").then(function(response) {
        self.extraunitlist = response.data;
        self.$root.$emit("extraunitall", response.data);
      });
    },
    Selected(id) {
      this.$root.$emit("extraunitselected", id);
    },
    Update() {
      let self = this;
      axios({
        method: "patch",
        url: "api/v1/extra-unit/id/" + self.extraunit.id,
        data: self.extraunit
      }).then(function(response) {
        self.Extraunitlist();
        self.extraunit = { name: "" };
        self.$store.state.saved_modal = "updated";
        self.$bvModal.hide("modal-extraunitset");
      });
    },
    Hidecreate() {
      if (this.$store.state.saved_modal == "create") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Create();
        } else {
          this.extraunitnew = { name: "" };
          this.$root.$emit("unitone", this.extraunitnew);
        }
      } else if (this.$store.state.saved_modal == "update") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Update();
        }
      }
      this.$store.state.saved_modal = null;
      this.$bvModal.show("modal-extraunitlist");
    },
    Create() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/extra-unit",
        data: self.extraunitnew
      }).then(function(response) {
        // self.extraunitlist.push(response.data);
        var a = [];
        a.push(response.data);
        var b = a.concat(self.extraunitlist);
        self.extraunitlist = b;
        self.$root.$emit("extraunitall", self.extraunitlist);
        self.$store.state.saved_modal = "created";
        self.extraunitnew = { name: "" };
        self.$bvModal.hide("modal-extraunit");
        self.sett = "create";
        self.$root.$emit("extraunitone", self.extraunitnew);
      });
    }
  },
  computed: {
    filteredRows() {
      return this.extraunitlist.filter(row => {
        const name = row.name.toString().toLowerCase();
        const searchTerm = this.filter.toLowerCase();

        return name.includes(searchTerm);
      });
    }
  },
  watch: {
    extraunit: {
      deep: true,
      handler(val, oldVal) {
        if (this.$store.state.saved_modal == null) {
          this.$store.state.saved_modal = "update";
        }
      }
    },
    extraunitnew: {
      deep: true,
      handler(val, oldVal) {
        if (val.name != "") {
          this.$store.state.saved_modal = "create";
        } else {
          this.$store.state.saved_modal = null;
        }
      }
    }
  },
  created() {
    this.$root.$emit("extraunitone", this.extraunitnew);
    this.$root.$emit("extraunitselected", this.select);
    this.Extraunitlist();
  }
};
</script>
<style scoped>
/* MODAL FORM */
.modal-form {
  padding: 10px;
}

.form-unit {
  margin-bottom: 20px;
}

.form-unit label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 12px 15px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
}

.form-input:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 15px;
  border-top: 1px solid #f1f2f6;
}

.btn-save {
  background: #a142f4;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  cursor: pointer;
}

.btn-save:hover {
  background: #8e39d9;
  transform: translateY(-1px);
}

/* LIST MODAL */
.modal-list {
  padding: 5px;
}

.modal-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 10px 15px 10px 38px;
  border-radius: 12px;
  width: 100%;
  outline: none;
  transition: 0.3s;
  font-weight: 500;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
  background: white;
}

.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 42px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  white-space: nowrap;
  transition: 0.2s;
}

.add-btn:hover {
  transform: translateY(-1px);
}

/* TABLE */
.modal-table-wrapper {
  max-height: 60vh;
  overflow-y: auto;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
}

.modal-table {
  width: 100%;
  border-collapse: collapse;
}

.modal-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.modal-table th {
  background: #f8fafc;
  padding: 14px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f2f6;
}

.modal-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f8fafc;
  font-size: 14px;
  color: #334155;
  vertical-align: middle;
}

.clickable-row {
  cursor: pointer;
  transition: 0.15s;
}

.clickable-row:hover {
  background: #faf8ff;
}

.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.font-bold {
  font-weight: 700;
}

/* ACTIONS */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.empty-row {
  text-align: center;
  padding: 40px !important;
  color: #94a3b8;
  font-style: italic;
}
</style>
